    import ComboCustomizeButton from "./ComboCustomizeButton";

    export default class MenuSelectionCard extends React.Component {
        constructor(props) {
            super(props);
            this.sendCardData = this.sendCardData.bind(this);

            this.selectedCardId = null;
            this.menuPrice = null;
            this.cardName = null;

           /* this.state = {
                validImages: {}
            };*/
            this.bindCardDataToDom = this.bindCardDataToDom.bind(this);
            this.getCalorieText = this.getCalorieText.bind(this);
            this.handleKeyDown = this.handleKeyDown.bind(this);
            this.handleImageError = this.handleImageError.bind(this);
            this.handleTileClick = this.handleTileClick.bind(this);
            this.checkIfCardIsSelected = this.checkIfCardIsSelected.bind(this);
            this.getPriceDetails = this.getPriceDetails.bind(this);
            this.getItemSubDetails = this.getItemSubDetails.bind(this);
            this.sendMoreOptionsData = this.sendMoreOptionsData.bind(this);
            //this.loadImages = this.loadImages.bind(this);   
        }

        handleImageError(e) {
            e.target.onerror = null;
            e.persist();
            e.target.remove();
        }

        bindCardDataToDom() {
            const reactRefThis = this;
            $(".AcomboMenuCardList").unbind().click(function () {
                MenuSelectionCard.selectedCardId = $(this).attr("id");
                MenuSelectionCard.cardName = $(this).attr("data-cardname");
                MenuSelectionCard.priceForCardOnly = $(this).attr("data-cardonlyprice");
                MenuSelectionCard.hasMoreOption = $(this).attr("data-hasMoreOption");
                reactRefThis.props.sendCardName(MenuSelectionCard.cardName);
                reactRefThis.props.sendCardOnlyPrice(MenuSelectionCard.priceForCardOnly);
            });
        }

        componentDidUpdate(prevProps) {
            this.bindCardDataToDom();
           /* if (prevProps.menuItems !== this.props.menuItems) {
                this.loadImages();
            }*/
        }
      /*  loadImages(){
            const { menuOrderCardData } = this.props;
            *//* if (DE.ProgressIndicator) {
                DE.ProgressIndicator.hideIndicator();
            }*//*
            menuOrderCardData.forEach((menuOrderCard, index) => {
                const imageUrl = menuOrderCard.MenuItemDetail.ImagePath;

                if (!imageUrl) return;

                const img = new Image();

                img.onload = () => {
                    var validImages = Object.assign({}, this.state.validImages);
                    validImages[index] = true;
                    console.log("Image loaded successfully for index:", index, "URL:", imageUrl);   
                    this.setState({
                        validImages: validImages
                    });
                };

                img.onerror = () => {
                    var validImages = Object.assign({}, this.state.validImages);
                    validImages[index] = false;
                    console.log("Image failed to load for index:", index, "URL:", imageUrl);    
                    this.setState({
                        validImages: validImages
                    });
                };

                img.src = imageUrl;
            });
        }*/
        componentDidMount() {
            this.bindCardDataToDom();
           // this.loadImages();

        }
        
        getCalorieText(calorie, maxCalorie, separator) {
            return calorie > 0
                ? `${this.props.calorieAdds} ${maxCalorie ? calorie + separator + maxCalorie : calorie}`
                : calorie < 0
                ? `${this.props.calorieSubtracts} ${maxCalorie ? (maxCalorie * -1) + separator + (calorie * -1) : (calorie * -1)}`
                : "0";
        }

        sendCardData(e) {
            e.preventDefault();
            $("#noModal").attr("id", "information_modal");
            this.props.sendSelectedCardId(
                MenuSelectionCard.selectedCardId,
                MenuSelectionCard.cardName,
                MenuSelectionCard.priceForCardOnly,
                MenuSelectionCard.hasMoreOption
            );
        }

        handleKeyDown(event) {
            if (event.keyCode === 13) {
                setTimeout(() => {
                    $(document.activeElement).find(".AcomboMenuCardList").trigger("click");
                }, 100);
            }
        }

        checkIfCardIsSelected(cardId) {
            return this.props.currentSelectedItems && this.props.currentSelectedItems.some(item => item.id == cardId);
        }

        getItemSubDetails(cardId) {
            const selectedItem = this.props.currentSelectedItems?.find(item => item.id == cardId);
            return selectedItem?.subTitle ? (
                <p id={selectedItem.subtitleId} className="item-description">
                    {selectedItem.subTitle}
                </p>
            ) : null;
        }

        getPriceDetails(item) {
            const cardId = item.Id;
            const defaultDetails = {
                caloriesText: this.props.caloriesText,
                calorieAbbr: this.props.calorieAbbr,
                Price: item.Price,
                baseCal: item.BaseCalories,
                maxCalories: item.MaxCalories,
                calorieSeparator: item.CalorieSeparator,
            };

            const selectedItem = this.props.currentSelectedItems?.find(item => item.id == cardId);

            const details = selectedItem
                ? {
                      Price: selectedItem.price || defaultDetails.Price,
                      baseCal: selectedItem.calories ?? defaultDetails.baseCal,
                      maxCalories: selectedItem.maxCalories || defaultDetails.maxCalories,
                      calorieSeparator: selectedItem.calorieSeparator || defaultDetails.calorieSeparator,
                      calorieAbbr: selectedItem.calorieAbbr || defaultDetails.calorieAbbr,   
                      caloriesText: selectedItem.caloriesText || defaultDetails.caloriesText
                  }
                : defaultDetails;

            const hasPrice = details.Price !== "$0.00" && details.Price !== "0.00";
            const hasCalories = details.baseCal != null && details.baseCal !== "";

            if (hasPrice || hasCalories) {
                return (
                    <h3>
                        {hasPrice && <span className="customizer-price">{selectedItem ? `+$${parseFloat(details.Price).toFixed(2)}` : `+${details.Price}`}</span>}
                        {hasPrice && hasCalories && " | "}
                        {hasCalories && (
                            <span>
                                <span>{this.getCalorieText(details.baseCal, details.maxCalories, details.calorieSeparator)}</span>
                                <abbr aria-label={details.caloriesText}> {details.calorieAbbr}</abbr>
                            </span>
                        )}
                    </h3>
                );
            }
        }

        handleTileClick(e) {
            e.preventDefault();
            e.stopPropagation();
            const inner = e.target.closest(".AcomboMenuCardList");
            if (!inner) {
                const target = e.currentTarget.querySelector(".AcomboMenuCardList");
                if (target) {
                    target.click();
                }
            }
        }

        sendMoreOptionsData(e, toppingdats, item) {
            e.preventDefault();
            e.stopPropagation();
            $("#noModal").attr("id", "information_modal");
            let $this = this;
        
           /* setTimeout(() => {
                const maxSelectCheckCountCal = $("#batch0").attr("data-maxselects");
                const checkedCountInputCal = $("#batch0 #comboRadioBtn > input[type=checkbox]:checked").length;
                if (maxSelectCheckCountCal > 1) {
                    if (checkedCountInputCal >= maxSelectCheckCountCal) {
                        $("#batch0 #comboRadioBtn > input[type=checkbox]:not(:checked)").attr("disabled", true);
                    } else {
                        $("#batch0 #comboRadioBtn > input[type=checkbox]").attr("disabled", false);
                    }
                }
            }, 500);*/

            this.props.updateModalData(toppingdats);
            this.props.updateModalHeader(item.Name);
            this.props.updateModalId(item.Id);
            this.props.updateModalImage(item.ImagePath);
            this.props.sendCardOpensModalState(false);
            this.props.sendModalContentResetStatus(false);
            this.props.sendCustomizedBtnStatus(true);


            $("#subMenusContainer").hide();
            $("#modalContent").show();

            
            const clickedModalId = e.currentTarget.getAttribute("data-modalId");
            const filteredItem = this.props.currentSelectedItems?.find(item => item.id == clickedModalId);

            setTimeout(() => {
                
                if (filteredItem) {
                    let subSelectedId = filteredItem.subtitleId;
                    subSelectedId = Array.isArray(subSelectedId) ? subSelectedId : subSelectedId.split(',').map(id => id.trim());
                    if (Array.isArray(subSelectedId)) {
                        subSelectedId.forEach(id => {
                            const selectedItem = $(`input[data-toppingid="${id}"]`);
                            if (selectedItem.length > 0) {
                                $(selectedItem).prop("checked", true);
                                const cartItem = $(selectedItem).closest(".cart-items");
                                cartItem.addClass("selected");
                            } else {
                                var SelectedChevron = $(`i[data-toppingid="${id}"]`);
                                if (SelectedChevron.length > 0) {
                                    SelectedChevron.closest(".cart-items").addClass("selected");
                                    SelectedChevron.attr("data-selected", "selected");
                                }
                            }
                        });
                    }


                }
                $this.props.updateRenderModalState();
                
                $('#information_modal').modal('show')
            

            }, 300);

            setTimeout(() => {
                let requiredStatus = $('#modalContent .combo-required-text').length;
                if (requiredStatus > 0) {
                    $("#information_modal #comboSaveButton").attr("disabled", "disabled");
                } else {
                    $("#information_modal #comboSaveButton").attr("disabled", false);

                }

            }, 500);
        }

        render() {
           // const { validImages } = this.state;
            const menuOrderCardSets = this.props.menuOrderCardData.map((menuOrderCard, index) => (
                <div
                    key={menuOrderCard.MenuItemDetail.Id}
                    className="col-lg-12 d-flex align-self-stretch pad-righ-0 ihopCustomizeMenu2"
                >
                    <a href="#" className="ihopCustomize" role="button" tabIndex="-1">
                        <div
                            tabIndex="0"
                            key={menuOrderCard.MenuItemDetail.Id}
                            aria-label={menuOrderCard.MenuItemDetail.Name}
                            onClick={this.sendCardData}
                            id={menuOrderCard.MenuItemDetail.Id}
                            data-isdefault={menuOrderCard.MenuItemDetail.IsDefault}
                            data-cardonlyprice={menuOrderCard.MenuItemDetail.CalcPrice}
                            data-cardname={menuOrderCard.MenuItemDetail.Name}
                            data-hasMoreOption={menuOrderCard.optionGroups.length}
                            className={`category-item position-relative AcomboMenuCardList ${
                                this.checkIfCardIsSelected(menuOrderCard.MenuItemDetail.Id) ? "active" : ""
                            }`}
                        >
                            <div className="category-item-overlay">
                                <div className="category-description-section">
                                   {/* <div className="image-placeholder" key={index}>
                                        {validImages[index] && (
                                            <img
                                                src={menuOrderCard.MenuItemDetail.ImagePath}
                                                alt={
                                                    menuOrderCard.MenuItemDetail.ModifierSlugName || "Modifier Image"
                                                }
                                                className="category-img img-fluid"
                                                loading="lazy"
                                                decoding="async"
                                            />
                                        )}
                                        
                                    </div>*/}
                                    <div className="category-description">
                                        <h2>{menuOrderCard.MenuItemDetail.Name}</h2>
                                        {this.getItemSubDetails(menuOrderCard.MenuItemDetail.Id)}
                                        {this.getPriceDetails(menuOrderCard.MenuItemDetail)}
                                    </div>
                                </div>
                                {menuOrderCard.optionGroups && menuOrderCard.optionGroups.length > 0 ? (
                                    <div className="customize-button-section">
                                        <button
                                            className="btn btn-rewards float-right"
                                            id="modal_view_right"
                                            data-toggle="modal"
                                            data-modalId={menuOrderCard.MenuItemDetail.Id}
                                            data-modalName={menuOrderCard.MenuItemDetail.Name}
                                            data-target="#information_modal"
                                            onClick={(e) => this.sendMoreOptionsData(e, menuOrderCard.optionGroups, menuOrderCard.MenuItemDetail)}
                                        >
                                            {this.props.customizeButtonText}
                                        </button>
                                    </div>
                                ) : (
                                    <div className="checkmark-section">
                                        <span className="checkmark">
                                            <i className="bi bi-check"></i>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </a>
                </div>
            ));

            return (
                <div>
                    <div className="row">{menuOrderCardSets}</div>
                </div>
            );
        }
    }
